import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const setField = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) {
      setError("La contrasena debe tener al menos 6 caracteres");
      return;
    }
    setLoading(true);
    const r = await register(form.email.trim(), form.password, form.name.trim());
    setLoading(false);
    if (r.ok) nav("/dashboard");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen bg-[#F1F5F9]">
      <div className="flex min-h-screen flex-col items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <div className="mb-6 flex flex-col items-center text-center">
            <div className="mb-4 flex h-24 w-24 items-center justify-center rounded-2xl bg-white p-2 shadow-lg sm:h-28 sm:w-28">
              <img
                src="/assets/logo.svg"
                alt="Ciudad Enfermeria San Luis Potosi"
                className="h-full w-full object-contain"
              />
            </div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              Crear cuenta de enfermera
            </h1>
            <p className="mt-1 text-sm font-medium text-slate-500">
              Acceso seguro al programa de cuidados
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label className="mb-1.5 block text-sm font-semibold text-slate-700">
                  Nombre completo
                </Label>
                <Input
                  required
                  value={form.name}
                  onChange={setField("name")}
                  placeholder="Maria Lopez"
                  className="h-12 text-base"
                  data-testid="register-name-input"
                />
              </div>
              <div>
                <Label className="mb-1.5 block text-sm font-semibold text-slate-700">
                  Correo electronico
                </Label>
                <Input
                  type="email"
                  required
                  value={form.email}
                  onChange={setField("email")}
                  placeholder="tu@correo.com"
                  className="h-12 text-base"
                  data-testid="register-email-input"
                />
              </div>
              <div>
                <Label className="mb-1.5 block text-sm font-semibold text-slate-700">
                  Contrasena (min 6)
                </Label>
                <Input
                  type="password"
                  required
                  value={form.password}
                  onChange={setField("password")}
                  placeholder="******"
                  className="h-12 text-base"
                  data-testid="register-password-input"
                />
              </div>
              {error && (
                <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-700" data-testid="register-error">
                  {error}
                </div>
              )}
              <Button
                type="submit"
                disabled={loading}
                className="h-12 w-full rounded-xl bg-[#1D4ED8] text-base font-semibold hover:bg-[#1E40AF]"
                data-testid="register-submit-btn"
              >
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Crear cuenta"}
              </Button>
            </form>

            <div className="mt-6 text-center text-sm text-slate-600">
              Ya tienes cuenta?{" "}
              <Link to="/login" className="font-semibold text-[#1D4ED8] hover:underline" data-testid="register-login-link">
                Iniciar sesion
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
